/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Art_3_DetailInputs */

const en_svc_agents_art_3_detail = /** @type {(inputs: Svc_Agents_Art_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales owner approves before sending`)
};

const lv_svc_agents_art_3_detail = /** @type {(inputs: Svc_Agents_Art_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārdevējs apstiprina pirms nosūtīšanas`)
};

/**
* | output |
* | --- |
* | "Sales owner approves before sending" |
*
* @param {Svc_Agents_Art_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_art_3_detail = /** @type {((inputs?: Svc_Agents_Art_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Art_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_art_3_detail(inputs)
	return en_svc_agents_art_3_detail(inputs)
});